import { useRef } from 'react';
import { useGSAP } from '@gsap/react';
import { gsap } from 'gsap';

export function AmbientBackground() {
  const rootRef = useRef<HTMLDivElement>(null);

  useGSAP(
    () => {
      const bubbles = gsap.utils.toArray<HTMLElement>('.bubble');
      bubbles.forEach((bubble, index) => {
        gsap.to(bubble, {
          x: index % 2 === 0 ? 8 : -8,
          y: -18,
          rotation: index % 2 === 0 ? 4 : -4,
          duration: 6.5 + index,
          repeat: -1,
          yoyo: true,
          ease: 'sine.inOut',
          delay: index * -1.2,
        });
      });

      gsap.to('.gloss--1', {
        xPercent: 20,
        duration: 8,
        repeat: -1,
        yoyo: true,
        ease: 'sine.inOut',
      });
      gsap.to('.gloss--2', {
        xPercent: -18,
        duration: 9,
        repeat: -1,
        yoyo: true,
        ease: 'sine.inOut',
      });
    },
    { scope: rootRef },
  );

  return (
    <div ref={rootRef} className="ambient" aria-hidden="true">
      <span className="bubble bubble--1" />
      <span className="bubble bubble--2" />
      <span className="bubble bubble--3" />
      <span className="bubble bubble--4" />
      <span className="gloss gloss--1" />
      <span className="gloss gloss--2" />
    </div>
  );
}
